import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const Benefits = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-25">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-26">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-27">
        De keuze is aan jou
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-28">
        Wetenschap laat zien dat we niet moeten straffen. Toch doen veel baasjes
        dit nog wel. Honden zijn hierdoor agressiever en er is meer
        probleemgedrag.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-29">
        Ga jij wel de stap zetten en dit voortaan wel anders doen?
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-30">
        Een goede eerste stap is om het webinar van Amee te volgen.{' '}
        <a href="https://stresslessdogs.nl/mcc-gpm-adv1" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-31">
          Klik hier om te zien of ze het webinar nog geeft.
        </a>
      </p>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-32">
        <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-33">
          Nu is de vraag:
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-34">
          Ga jij nog langer een methode gebruiken die zelfs de grondlegger heeft
          verworpen? Of kies je voor de wetenschappelijk onderbouwde benadering
          die Mech zou goedkeuren?
        </p>
        <ul className="space-y-4 mb-6" data-id="element-35">
          <li className="flex items-start" data-id="element-36">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-37" />
            <span data-id="element-38">
              <strong data-id="element-39">Wil je blijven domineren?</strong> Of leren communiceren
              en samenwerken?
            </span>
          </li>
          <li className="flex items-start" data-id="element-40">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-41" />
            <span data-id="element-42">
              <strong data-id="element-43">Wil je blijven straffen?</strong> Of begrijpen waarom je
              hond doet wat hij doet?
            </span>
          </li>
          <li className="flex items-start" data-id="element-44">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-45" />
            <span data-id="element-46">
              <strong data-id="element-47">Wil je blijven forceren?</strong> Of een echte band
              opbouwen op basis van vertrouwen?
            </span>
          </li>
        </ul>
        <p className="italic" data-id="element-48">
          In 90 minuten leer je eindelijk wat de wetenschapper die de dominantie
          theorie bedacht ECHT bedoelde. Het eerstvolgende gratis{' '}
          {replaceWebinarWithLink('webinar')} is vandaag en morgen.
        </p>
      </div>
    </section>;
};